export default __webpack_public_path__ + "static/media/Oil2Gas_01.8fca0514.png";